import { BasePayloadMapper } from '@ps/utils';
import { GetQuestionsRequestDto } from '../dtos/questions.dto';

export interface QuestionsListParams {
  search: string;
  categories: string;
}

export class QuestionsPayloadMapper extends BasePayloadMapper<
  QuestionsListParams,
  GetQuestionsRequestDto
> {
  public toPayload(params: QuestionsListParams): GetQuestionsRequestDto {
    return {
      limit: 10,
      page: 1,
      search: params.search,
      categories: params.categories,
    };
  }
}
